// @flow
import {assert} from "@swarm2/assert"
import {redux, selectors as S} from "@swarm2/core"
import {createStore, compose} from "redux"
import _ from "lodash"
import {reducer} from "./Reducers"

const isOffline = S.flags.offline()
const enableLogging = S.flags.logFirebase()
assert(isOffline || (redux && redux.config), "no firebase config?", redux)

// https://github.com/zalmoxisus/redux-devtools-extension
const withDevtools = !window.__REDUX_DEVTOOLS_EXTENSION__
  ? _.identity
  : window.__REDUX_DEVTOOLS_EXTENSION__({
      actionsBlacklist: ["TICK"],
    })

export function createReduxStore() {
  // $FlowFixMe
  return createStore(
    reducer,
    undefined,
    compose(...redux.withMiddleware({isOffline, enableLogging}), withDevtools),
  )
}



// WEBPACK FOOTER //
// ./src/redux/Store.js